import { createContext, useContext } from 'react'

/**
 * Lets the app set which chain RainbowKit should connect the wallet on.
 *
 * RainbowKit connects via `connectAsync({ chainId: initialChain.id })`, so the
 * wallet lands directly on the requested chain — no fragile post-connect chain
 * switch (which previously dropped the connection and logged the user out the
 * first time they picked a non-COTI network).
 *
 * Kept in its own module (no React component export) so the provider file
 * stays Fast-Refresh friendly.
 */
export interface InitialChainContextValue {
  /** Set the chain (by numeric id) the next connect should target. */
  setInitialChainId: (chainId: number) => void
}

export const InitialChainContext = createContext<InitialChainContextValue>({
  setInitialChainId: () => {},
})

export const useInitialChainSelector = () => useContext(InitialChainContext)
